
define('text!fusion/ui/controls/fusion-toolbar.html',[],function () { return '<div>\r\n    <ul>\r\n        <!-- ko transclude: \'\' -->\r\n        <!-- /ko -->\r\n    </ul>\r\n</div>\r\n';});

